import React from 'react';
import '@progress/kendo-theme-default/dist/all.css';
import { Select } from 'antd';
import OpenAndCloseCashier from './OpenAndCloseCashier';
import { Button } from '@progress/kendo-react-buttons'
import { withRouter } from 'react-router-dom';
import HeaderMenu from '../../locale/head_menu.json'
import Lang from '../../lang'
import services from '../../services';

var moment = require('moment');
const { Option } = Select;

class NavBar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            yearlist: null,
            mainMenuDisplay: {
                key: null
            },
            subMenuDisplay: {
                key: null
            }
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.yearOptions();
    }
    componentDidUpdate(preProps) {
        if (this.props.date && preProps.date !== this.props.date) {
            this.yearOptions();
        }
    }

    handleSubmenu = (url) => {
        this.props.history.push({
            pathname: url,
            state: {
                topBarMenu: this.props.topBarMenuOption,
                date: new Date(),
                paramoption: { back: true }
            }
            //state: { topBarMenu: this.props.topBarMenuOption, date: new Date() }
        })
    }

    handleLogout = () => {
        let data = {
            "username": window.localStorage.getItem('username'),
            "Password": "0x7CCEBE3E8550AE16ABBEA1BD8014F8DEE2BF5EFBA243682E86BF99873245980C5B570E97DBB9C1C31C2F82CA4110348736EB5266F76F278410F3EABF7B1FA1AE"
        }
        services.apiCall.requestApi("/User/AuthenticateLogout", data, 'post')
        window.localStorage.removeItem('token');
        // retira as persistencias das grids
        Object.keys(window.localStorage).forEach(key => {
            if (key.startsWith("TlkTable_")) {
                window.localStorage.removeItem(key);
            }
        });

        window.location = '/'
        const token = window.localStorage.getItem('token')
    }

    updateYear = (e) => {
        this.props.updateYear(e)
    }

    changeRoute = (row) => {
        console.log('roooooooooow', row)
        if (row && (row.tableName === 'CaixaTable' || row.tableName === 'AllCreditDetails' || row.tableName === 'AllServicesDetails')) {
            if (row.name === 'Efetuar Venda') {
                row['serviceNo'] = 1
            }
            if (row.name === 'Depósitos') {
                row['serviceNo'] = 2
            }
            if (row.name === 'Folha de Caixa') {
                row['serviceNo'] = 3
            }
        }
        this.props.history.push({
            pathname: row.url,
            state: {
                topBarMenu: this.props.topBarMenuOption,
                paramoption: row,
                date: new Date()
            }
        });
    }

    yearOptions() {
        if (!this.props.date) {
            return;
        }
        let year = new Date();
        year = year.getFullYear();
        let Preyear = year - 20;
        let yearlistArray = [];
        this.setState({
            yearlist: null
        })
        if (this.props.linkData && this.props.linkData.navbarOptionsYear) {
            while (Preyear <= year) {
                yearlistArray.push(year);
                year--;
            }
            let yearlist = yearlistArray.map((_r, i) => (
                <Option value={_r}> {_r} </Option>
            ))
            this.setState({
                yearlist: yearlist
            })
        }
    }

    mainMenuHover = (index) => {
        let mainMenuDisplay = {}
        mainMenuDisplay['key'] = index
        this.setState({ mainMenuDisplay })
    }

    subMenuHover = (index) => {
        let subMenuDisplay = {}
        subMenuDisplay['key'] = index
        this.setState({ subMenuDisplay })
    }

    /*  para renderizar o conteúdo html da página   */

    render() {
        let pathname = this.props.location.pathname;
        pathname = pathname.replace("/", "")
        return (
            <>
                <nav className={"navbar custom-nav navbar-expand-md justify-content-end"}>
                    <button className="navbar-toggler" type="button" style={{ paddingRight: "15px" }} data-toggle="collapse" data-target="#collapsibleNavbar">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="container-fluid">
                        {
                            !this.props.moduleName &&
                            <div style={{ float: "left", display: "flex", listStyleType: "none" }}>
                                {
                                    this.props.topBarMenuOption && this.props.topBarMenuOption.length > 0 &&
                                    this.props.topBarMenuOption.map((_opt, inx) => (
                                        `/${pathname}` === _opt.url ?
                                            <li className="mr-2 mt-1" key={inx} >
                                                {
                                                    (this.props.linkData && this.props.linkData.nevOptionChange && this.props.linkData.nevOptionChange.length > 0) || (this.props.optionMenuArray && this.props.optionMenuArray.length > 0) ?
                                                        <>
                                                            {
                                                                this.props.linkData && this.props.linkData.nevOptionChange && this.props.linkData.nevOptionChange.length > 0 &&
                                                                <div className="multilevel-menu">
                                                                    <div className="dropdown">
                                                                        <span className="cursor-pointer submenutabsactive " data-toggle="dropdown" ><u> {Lang.langCheck.langRequest(_opt.name)} </u></span>

                                                                        <ul className="dropdown-menu multi-level" style={{ zIndex: "110" }} role="menu" aria-labelledby="dropdownMenu">
                                                                            {
                                                                                this.props.linkData.nevOptionSubMenu &&
                                                                                Object.keys(this.props.linkData.nevOptionSubMenu).map((_key, ind) => (
                                                                                    <li className="dropdown-item d-flex align-items-center justify-content-between dropdown-submenu" key={ind}
                                                                                    ><span>{_key} <span style={{ float: 'right' }}></span></span>
                                                                                        <ul className="dropdown-menu second-level">
                                                                                            {
                                                                                                this.props.linkData.nevOptionSubMenu[_key].map((row, inx) => (
                                                                                                    row.name === this.props.linkData.prevPageName ?
                                                                                                        <li className="dropdown-item active" key={inx}
                                                                                                        ><span onClick={() => this.changeRoute(row)}>{Lang.langCheck.langRequest(row.name)}</span></li>
                                                                                                        :
                                                                                                        <li className="dropdown-item" key={inx}
                                                                                                        >
                                                                                                            <span onClick={() => this.changeRoute(row)}>{Lang.langCheck.langRequest(row.name)}</span>
                                                                                                        </li>
                                                                                                ))
                                                                                            }
                                                                                        </ul>
                                                                                    </li>
                                                                                ))
                                                                            }
                                                                            {
                                                                                this.props.linkData.nevOptionChange.map((row, i) => (
                                                                                    row.name === this.props.linkData.prevPageName ?
                                                                                        <li className="dropdown-item d-flex align-items-center justify-content-between active" key={i}
                                                                                        ><span onClick={() => this.changeRoute(row)}>{Lang.langCheck.langRequest(row.name)}</span></li>
                                                                                        :
                                                                                        <li className="dropdown-item" key={i}
                                                                                        >
                                                                                            <span onClick={() => this.changeRoute(row)}>{Lang.langCheck.langRequest(row.name)}</span>
                                                                                        </li>
                                                                                ))
                                                                            }
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            }

                                                            {
                                                                this.props.optionMenuArray && this.props.optionMenuArray.length > 0 &&

                                                                <div className="multilevel-menu">
                                                                    <div className="dropdown">
                                                                        <span className="cursor-pointer submenutabsactive" data-toggle="dropdown" ><span>  {Lang.langCheck.langRequest(_opt.name)} </span></span>


                                                                        {
                                                                            this.props.optionMenuArray &&
                                                                            <ul className="dropdown-menu multi-level" role="menu" aria-labelledby="dropdownMenu">
                                                                                {
                                                                                    this.props.optionMenuArray.length > 0 &&
                                                                                    this.props.optionMenuArray.map((_option, i) => (
                                                                                        _option.main &&
                                                                                            _option.sub_menu ?
                                                                                            <li key={i} className="dropdown-submenu">
                                                                                                {
                                                                                                    this.props.selectedMainOption === _option.main ?
                                                                                                        <span className="dropdown-item active" tabindex="-1" >{_option.main}</span>
                                                                                                        :
                                                                                                        <span className="dropdown-item" tabindex="-1" >{_option.main}</span>
                                                                                                }
                                                                                                <ul className="dropdown-menu second-level">
                                                                                                    {
                                                                                                        _option.sub_menu.map((lstOption, k) => (
                                                                                                            this.props.selectedtitelotion === lstOption.display ?
                                                                                                                <li className="dropdown-item active" onClick={() => this.props.changeOption(i, k)} >{lstOption.display}</li>
                                                                                                                :
                                                                                                                <li className="dropdown-item" onClick={() => this.props.changeOption(i, k)} >{lstOption.display}</li>
                                                                                                        ))
                                                                                                    }
                                                                                                </ul>
                                                                                            </li>
                                                                                            :
                                                                                            <li className="dropdown-item" >{_option.main}</li>
                                                                                    ))
                                                                                }
                                                                            </ul>

                                                                        }
                                                                    </div>
                                                                </div>
                                                            }
                                                        </>
                                                        :
                                                        <span className="cursor-pointer submenutabsactive" ><span> {_opt.name} </span></span>
                                                }

                                            </li>
                                            :
                                            <li className="mr-2 mt-1" key={inx} >
                                                <span className="cursor-pointer submenutabs" onClick={() => this.handleSubmenu(_opt.url)}><span>  {_opt.name}</span></span>
                                            </li>
                                    ))
                                }
                            </div>
                        }
                        <div className="collapse navbar-collapse justify-content-end" id="collapsibleNavbar">
                            {
                                this.props.moduleName &&
                                <ul className="navbar-nav mr-auto multi-level-menu">
                                    {
                                        HeaderMenu[this.props.moduleName].map((_r1, i1) => (
                                            _r1.menu ?
                                                <li key={ i1 } className={(pathname === _r1.url) || (this.props.linkData && _r1.name === this.props.linkData.prevPageName) ? "nav-item dropdown havemenu active" : "nav-item dropdown havemenu"}>
                                                    <span className={"nav-link dropdown-toggle"}  data-toggle="dropdown"> {Lang.langCheck.langRequest(_r1.name)}   </span>
                                                    <ul className="dropdown-menu">
                                                        {
                                                            _r1.menu.map((_r2, i2) => (
                                                                _r2.submenu ?
                                                                    <li key={i2}><span className={this.props.linkData && _r2.name === this.props.linkData.prevPageName ? "dropdown-item d-flex align-items-center justify-content-between active" : "dropdown-item d-flex align-items-center justify-content-between"}  > {Lang.langCheck.langRequest(_r2.name)} <i className="fas fa-angle-right ml-2" style={{ float: "right" }}></i> </span>
                                                                        <ul className="submenu dropdown-menu">
                                                                            {
                                                                                _r2.submenu.map((_r3, i3) => (
                                                                                    <li key={ i3 }><span className={this.props.linkData && _r3.name === this.props.linkData.prevPageName ? "dropdown-item" : "dropdown-item"} onClick={() => this.changeRoute(_r3)}> {Lang.langCheck.langRequest(_r3.name)} </span></li>
                                                                                ))
                                                                            }
                                                                        </ul>
                                                                    </li>
                                                                    :
                                                                    <li key={i2}><span className={_r2.name === this.props.linkData.prevPageName ? "dropdown-item" : "dropdown-item"} onClick={() => this.changeRoute(_r2)}> {Lang.langCheck.langRequest(_r2.name)} </span></li>
                                                            ))
                                                        }
                                                    </ul>
                                                </li>
                                                :
                                                <li key = { i1 } className={(`/${pathname}` === _r1.url) || (this.props.linkData && _r1.name === this.props.linkData.prevPageName) ? "nav-item active" : "nav-item"}> <span className="nav-link" onClick={() => this.changeRoute(_r1)}> {Lang.langCheck.langRequest(_r1.name)} </span> </li>
                                        ))
                                    }
                                </ul>

                            }
                            {
                                this.state.yearlist &&
                                <>
                                    <label style={{ margin: "auto" }} className="mr-2">Campanha</label>
                                    <Select className='mr-2' style={{ width: "100px" }} onChange={(e) => this.updateYear(e)} value={this.props.year} showSearch placeholder="Years" optionFilterProp="children" >
                                        {
                                            this.state.yearlist
                                        }
                                    </Select>
                                </>
                            }

                            {
                                this.props.linkData && this.props.linkData.OpenAndCloseCashier &&
                                <OpenAndCloseCashier date={new Date()}
                                    parsed={this.props.parsed}
                                    updateParam={() => this.props.updateParam()}

                                />
                            }

                            {/* < ul className="navbar-nav custom-menu float-right mr-4" >
                                <li className="nav-item dropdown">
                                    <a className="nav-link " href="#" id="navbardrop" data-toggle="dropdown"> */}
                                        {/* <span className="d-inline-block first-icon  bg-well"><i className="fas fa-bell"></i></span>  */
                                        }
                                        {/* <span className="d-inline-block first-icon k-icon k-i-notification"></span>
                                    </a>
                                    <div className="dropdown-menu well-alert">
                                        <a className="dropdown-item" href="#">
                                            <span className="content">
                                                <p className="theme-color mb-2">Alertas</p>
                                                <p className="d-flex justify-content-between">
                                                    <span>Reinaldo Farujo</span>
                                                    <span className="pl-2">25/4</span>
                                                </p>
                                                <p className="small">Instituto dos Vinhos do Douro e do Porto</p>
                                            </span>
                                        </a>
                                        <a className="dropdown-item" href="#">
                                            <span className="content">

                                                <p className="d-flex justify-content-between">
                                                    <span>Reinaldo Farujo</span>
                                                    <span>25/4</span>
                                                </p>
                                                <p className="small">Instituto dos Vinhos do Douro e do Porto</p>
                                            </span>
                                        </a>
                                    </div>
                                </li>
                            </ul> */}

                            <ul className="navbar-nav custom-menu float-right mr-2 user-alert-head">
                                <li className="nav-item dropdown">
                                    <span className="nav-link d-flex justify-content-between cursor-pointer" id="navbardrop" data-toggle="dropdown">
                                        <span className="d-inline-block first-icon">{window.localStorage.getItem('username').substr(0, 2).toUpperCase()}</span>
                                        <div className="dropdown-toggle">
                                            <span>{window.localStorage.getItem('username')}</span>
                                        </div>
                                    </span>
                                    <div className="dropdown-menu user-alert">
                                        <span className="dropdown-item cursor-pointer">
                                            <span className="content">
                                                <p>{window.localStorage.getItem('username')}</p>
                                                <p className="small">Instituto dos Vinhos do Douro e do Porto</p>
                                            </span>
                                        </span>
                                        <span onClick={this.handleLogout} className="dropdown-item cursor-pointer" >
                                            <span className="content">
                                                <p>Sair <span className="float-right mt-1 k-icon k-i-logout"></span></p>
                                            </span>
                                        </span>
                                    </div>

                                </li>

                            </ul>
                        </div>
                    </div>
                </nav>
            </>
        )
    }
}

export default withRouter(NavBar);